
import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { Prop } from "vue-property-decorator";

@Component
export default class AppHeader4 extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;
  @State("template", { namespace: "school" })
  private template!: any;

  @Prop({ default: false })
  private isUniversity!: boolean;
  @Prop({ default: null })
  private showAppLogin!: any;
  @Prop({ default: "Unknown" })
  private getAppLoginTitle!: string;
  @Prop({ default: "" })
  private email!: string;
  @Prop({ default: "" })
  private password!: string;
  @Prop({ default: false })
  private isForgotPassword!: boolean;
  @Prop({ default: null })
  private handleClickButton!: any;
  @Prop({ default: null })
  private closeAppLogin!: any;
  @Prop({ default: null })
  private submit!: any;
  @Prop({ default: null })
  private togglePassword!: any;

  private dropdownCandidate = false;
  private dropdownCompany = false;

  private get windowWidth() {
    return $(window).width() || 0;
  }

  private onEmail(event) {
    this.$emit("update:email", event.target.value);
  }

  private onPassword(event) {
    this.$emit("update:password", event.target.value);
  }

  private dropdownResponsive(type: string) {
    if (this.windowWidth > 768) return;

    if (type === "dropdown-candidate") {
      this.dropdownCandidate = !this.dropdownCandidate;
    } else {
      this.dropdownCompany = !this.dropdownCompany;
    }
  }
}
